import { emptyFunction } from 'utils'

import { AnimatePresence } from 'framer-motion'

import * as Styled from './styled'
import { InputRemoveButton } from './remove'
import { InputSearchButton } from './search'

interface IProps {
  value?: string
  handleRemoveClick: () => void
  isStaticView: boolean
  handleSearch?: () => void
}

export const InputActionButtons: React.FC<IProps> = ({
  value,
  handleRemoveClick,
  isStaticView,
  handleSearch = emptyFunction
}) => {
  const hasValue = !!value
  return (
    <Styled.InputActionButtonsWrapper $isStaticView={isStaticView}>
      <AnimatePresence>
        {hasValue && (
          <InputRemoveButton
            onRemoveClick={handleRemoveClick}
            isStaticView={isStaticView}
          />
        )}
      </AnimatePresence>
      <InputSearchButton
        isStaticView={isStaticView}
        handleSearch={handleSearch}
      />
    </Styled.InputActionButtonsWrapper>
  )
}
